var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"sticky",attrs:{"dismissible":"","show":_vm.value,"variant":"success","fade":""},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }